@if(isLoginModal){
<div class="close-btn">
    <ion-buttons slot="end">
        <ion-button fill="clear" (click)="close()">
            <ion-icon slot="icon-only" name="close"></ion-icon>
        </ion-button>
    </ion-buttons>
</div>
}
<ion-content scrollY="false">
    <div class="content-width auth-home" [ngClass]="{'isLoginModal': isLoginModal}">
        <figure>
            <img [src]="ioncourtLogo" alt="">
        </figure>
        <div class="ion-text-center title">
            {{'SCORE. TRACK. ANALYZE.' | translate}}
        </div>
        <ng-container *ngTemplateOutlet="footer"></ng-container>
    </div>
</ion-content>

<ng-template #footer>
    <ion-footer class="content-width mobile">
        @if(isLoginModal){
            <ion-button expand="block" class="primary-button" (click)="onAuthAction('signup')">
                {{'Create Account' | translate}}
            </ion-button>
            <ion-button expand="block" class="secondary-button" (click)="onAuthAction('signin')">
                {{'Sign In' | translate}}
            </ion-button>
        } @else {
            <ion-button expand="block" class="primary-button" [routerLink]="['/auth/signup']">
                {{'Create Account' | translate}}
            </ion-button>
            <ion-button expand="block" class="secondary-button" [routerLink]="['/auth/signin']">
                {{'Sign In' | translate}}
            </ion-button>
        }
    </ion-footer>
</ng-template>